
            const data = {"name":"facebook","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M43.47 19.81h-9.19v-6a2.46 2.46 0 012.1-2.81 2.36 2.36 0 01.46 0h6.46V1.07L34.39 1a11.27 11.27 0 00-12.14 10.39 10.82 10.82 0 000 1.8v6.62h-5.72V30h5.72v29h12V30h8.15z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                